import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  clickToEdit: {
    description: 'Accessible label for the inline edit button',
    defaultMessage: 'Click to edit',
    id: 'v9Iy4n',
  },
});
